import { render, staticRenderFns } from "./ClubBaseLayout.vue?vue&type=template&id=234cc0bb&scoped=true&"
import script from "./ClubBaseLayout.vue?vue&type=script&lang=js&"
export * from "./ClubBaseLayout.vue?vue&type=script&lang=js&"
import style0 from "./ClubBaseLayout.vue?vue&type=style&index=0&id=234cc0bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234cc0bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234cc0bb')) {
      api.createRecord('234cc0bb', component.options)
    } else {
      api.reload('234cc0bb', component.options)
    }
    module.hot.accept("./ClubBaseLayout.vue?vue&type=template&id=234cc0bb&scoped=true&", function () {
      api.rerender('234cc0bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/base/ClubBaseLayout/ClubBaseLayout.vue"
export default component.exports